/**
 * This helpers returns margins as per D3.js conventions.
 * @method getMargins
 * @param  hasBottomMargin Should this have a bottom margin?
 * @return Margins for a graph
 */
export default function getMargins(
  hasBottomMargin: any,
  period = '',
  isCutGrid = false
): any {
  const margins = {
    top: 15,
    left: 60,
    bottom: hasBottomMargin ? 10 : 50,
    right: 10,
  };

  const wideMargins = isCutGrid ? { ...margins, right: 4 } : margins;
  return period === 'customDate' ? { ...wideMargins, top: 30 } : wideMargins;
}
